var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M811.5,175H100V712a88.05,88.05,0,0,0,88.369,88H900V261.3C900,212.5,860.324,175,811.5,175ZM825,362.644L588.758,590h-0.2c-23.152,23-54.541,34.949-89.128,34.949S433.471,613,410.274,590h-0.62L175,362.8V276.261C268.964,369.145,439.987,535,439.987,535h0.054c15.3,16,36.133,22.8,59.119,22.8,24.349,0,46.26-9.8,61.76-26.8h0.108L825,275.051v87.593Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Email.5664870c.svg";
export { ForwardRef as ReactComponent };